import { z } from 'zod';
import { ContentProfile, Platform } from './profile.js';
export const WeekNumber = z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]);
/** `POST /api/generate-month` — the whole month is generated in one call. */
export const GenerateMonthRequest = z.object({
    profile: ContentProfile,
    month: z.string().min(1).max(40),
});
// GenerateMonthResponse carries typed WeekPlans and lives in plan.ts (it depends
// on the plan schemas). See `./plan.js`.
/**
 * `POST /api/draft` — generate a finished caption for one idea on demand.
 * Gated by possession of a valid `planId` (a planId only exists after lead
 * capture + finalize, so it already implies a captured lead). `platform` is an
 * optional override; defaults to the idea's assigned platform.
 */
export const DraftRequest = z.object({
    planId: z.string().uuid(),
    ideaId: z.string().min(1).max(40),
    platform: Platform.optional(),
});
// DraftResponse carries a Draft and lives in plan.ts. See `./plan.js`.
export const CaptureLeadRequest = z.object({
    email: z.string().email().max(254),
    name: z.string().min(1).max(120).optional(),
    profile: ContentProfile,
    month: z.string().min(1).max(40),
    // Honeypot — must be empty/absent. Bots tend to fill every field.
    hp: z.string().max(0).optional(),
});
export const CaptureLeadResponse = z.object({
    ok: z.literal(true),
    token: z.string(),
});
export const ApiError = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.unknown().optional(),
    }),
});
//# sourceMappingURL=requests.js.map